<template>
   <div class="navi">
        <div class="part"> 
            <ul id="nav_ul">
                <li v-for="(irow,key) in head_arr" :key="key" :class="{'on' : (key+1) == current_part}">{{irow}}</li>
                <!-- <li>PART Ⅱ</li>
                <li>PART Ⅲ</li>
                <li>PART Ⅳ</li>
                <li>PART Ⅴ</li>
                <li>PART Ⅵ</li> -->
            </ul>
        </div>

        <ul class="count">
            <li><span class="bold">{{current_question+1}}</span>/{{total_question}}</li>
            <li :class="{'out':is_out == true}">{{is_time}}</li>
        </ul>
    </div>
</template>

<script>
export default {
  name: 'inc_head',
  props: {
    time:{
      type: Object,
      default() {
          return {};
      },
    },
    total_question:Number,
    current_question:Number,
    current_part:Number,
    total_part:{
      type:Object,
      default(){
        return {};
      }
    }
  },
  data(){
    return {
      com_time:"",
      quesion_timer:null,
      is_out:false,
      head_arr:[],
      head_part:0,
      head_el:"",
      is_time:""
    }
  },
  
  watch: {
    time:{
      deep:true,
      handler(newData) {
         this.headTimer(newData.time);
      },
    },
    total_part:{
      deep:true,
      handler(newData){
        this.SeetingHead(newData.part);
      }
    }
  },
  mounted() {
   this.headTimer(this.time.time);
   
   this.SeetingHead(this.total_part.part);
   console.log(this.head_arr);
   console.log(this.parseRoman(6));
  },
  methods:{
    navScroll(current_part){
      let content = document.getElementById("nav_ul");
      content.scrollLeft += current_part * 90;
      console.log(current_part * 90);
    },
    SeetingHead(part){
      this.head_arr = [];
      for(var i = 1; i <= part; i++){
        this.head_arr.push("PART " + this.parseRoman(i))
      }
      if(this.current_part >= 5){
        setTimeout(()=>{
          this.navScroll(this.current_part);
        },10)
      }
    },
    headTimer(current_time){
      console.log("test" + current_time);
      this.is_out = false;
      clearInterval(this.quesion_timer);
      this.com_time = current_time / 1000;
      this.is_time = this.covertSeconds(this.com_time);
      this.quesion_timer = setInterval(()=>{
        // console.log(this.com_time);
        //  = this.covertSeconds(this.com_time - 1);
        this.com_time = this.com_time - 1;
        this.is_time = this.covertSeconds(this.com_time)
        if(this.com_time <= 0){
          clearInterval(this.quesion_timer);
          this.next();
        }else if(this.com_time <= 10){
          this.is_out = true;
        }
      },1000)
    },
    next(){
        this.$emit('next', true);
    },
    covertSeconds(seconds){
        if (seconds < 60) {
            return seconds;
        } else if (seconds < 3600){
            return Math.floor(seconds%3600/60) + ':' + seconds%60 + '';
        } else {
            return Math.floor(seconds/3600) + ':' + Math.floor(seconds%3600/60) + ':' + seconds%60;
        }
    },
    parseRoman(arabic){
      var lookup = {M:1000,CM:900,D:500,CD:400,C:100,XC:90,L:50,XL:40,X:10,IX:9,V:5,IV:4,I:1},roman = '',i;
      for ( i in lookup ) {
        while ( arabic >= lookup[i] ) {
          roman += i;
          arabic -= lookup[i];
        }
      }
      return roman;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
